import { typeDataToArray } from "./_typeDataToArray.js";
export const toArray = (source) => {
    return typeDataToArray(source.dataFunc);
};
